import { IWatrRequest } from '@nkr/models/index';

export const showUsAchBanking = (data: IWatrRequest): boolean => {
    if (data.isUsBank != null) {
        return data.isUsBank === true;
    }

    if (data.filesTaxesInUs != null) {
        return data.filesTaxesInUs === true;
    }

    return data.country === 1;
};

export const maskBankingValue = (raw: string | undefined | null, lastVisible = 4): string => {
    if (raw == null || String(raw).trim() === '') {
        return '—';
    }

    const s = String(raw).trim();

    if (s.length <= lastVisible) {
        return '•'.repeat(s.length);
    }

    const tail = s.slice(-lastVisible);
    const maskLen = Math.min(12, s.length - lastVisible);
    return `${'•'.repeat(maskLen)}${tail}`;
};

export const bankingDisplay = (raw: string | undefined | null, revealed: boolean, lastVisible = 4): string => {
    if (revealed) {
        if (raw == null || String(raw).trim() === '') {
            return '—';
        }

        return String(raw).trim();
    }

    return maskBankingValue(raw, lastVisible);
};
